import { configureStore } from '@reduxjs/toolkit';
import mitakeReducer from '../features/mitakeSlice';
import ecBindingReducer from '../features/ecBindingSlice';
import organizationReducer from '../features/organizationSlice';
import notifierReducer from '../features/notifierSlice';
import modalReducer from '../features/modalSlice';
import gssVitalReducer from '../features/gssVitalSlice';
import recurringMessageReducer from '../features/recurringMessageSlice';
import aiBotReducer from '../features/aiBotSlice';
import mainReducer from '../features/mainSlice';

export default configureStore({
  reducer: {
    main: mainReducer,
    aiBot: aiBotReducer,
    gssVital: gssVitalReducer,
    recurringMessage: recurringMessageReducer,
    mitake: mitakeReducer,
    ecBinding: ecBindingReducer,
    notifier: notifierReducer,
    modal: modalReducer,
    organization: organizationReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
